{
  "app": {
    "notification": "通知",
    "next": "下一條",
    "login": {
      "title": "RDA 會員登錄",
      "email": "電子郵件",
      "emailRequired": "電郵是必填的。",
      "emailValidate": "不是一個可用的電郵。",
      "password": "密碼",
      "passwordRequired": "密碼是必填的。",
      "button": "登錄",
      "showPassword": "顯示密碼",
      "registerTip": "還不是會員？",
      "registerLink": "立即註冊。",
      "forgotPassword": "忘記密碼？",
      "privacyLabel": "同意網站之",
      "tcLink": "條款及細則",
      "privacyAnd": " 以及 ",
      "ppLink": "私隱條例",
      "tcAndPpLink": "條款及細則以及私隱條例",
      "privacyRequired": "您必須同意條款及細則以及私隱條例。",
      "tcTitle": "條款及細則",
      "ppTitle": "私隱政策",
      "scrollToAccept": "請滾動到底部以接受",
      "accept": "接受",
      "close": "關閉",
      "decline": "拒絕",
      "loading": "加载中..."
    },
    "forgotPassword": {
      "title": "重置密碼",
      "forgotYourPassword": "忘記密碼？",
      "email": "電子郵件地址",
      "emailRequired": "電郵是必填的",
      "emailValidate": "無效的電子郵件地址",
      "sendCode": "發送驗證碼",
      "backToLogin": "返回登錄",
      "codeSentMessage": "驗證碼已發送到您的電子郵件地址。請輸入驗證碼以繼續。",
      "cannotReceiveCode": "無法收到驗證碼？",
      "verificationCode": "驗證碼",
      "codeRequired": "驗證碼是必填的",
      "newPassword": "新密碼",
      "passwordRequired": "密碼是必填的",
      "passwordMinLength": "密碼必須至少6個字元",
      "confirmPassword": "確認新密碼",
      "confirmPasswordRequired": "請填寫",
      "passwordsDoNotMatch": "密碼不匹配",
      "showPassword": "顯示密碼",
      "resetPassword": "確認",
      "codeSent": "驗證碼已發送到您的電子郵件。",
      "passwordUpdatedSuccessfully": "密碼已成功更新。",
      "back": "返回"
    },
    "navbar": {
      "schedule": "日程",
      "availability": "課堂報名",
      "leaveRequest": "請假",
      "accountSetting": "帳號設定",
      "classDetails": "課程詳情",
      "riderDetails": "騎生詳情",
      "riderProfile": "騎生檔案",
      "volunteerAttendance": "義工出席",
      "riderPairing": "騎生配對",
      "personalInfo": "個人資料",
      "websiteTerms": "網站條款與隱私政策",
      "logout": "登出"
    },
    "personalInfo": {
      "title": "個人資料",
      "name": "姓名",
      "mobile": "手機號碼",
      "dateOfBirth": "出生日期",
      "joinDate": "加入日期",
      "emergencyName": "緊急聯絡人",
      "emergencyMobile": "緊急聯絡電話",
      "grade": "等級"
    },
    "schedule": {
      "upcomingClass": "即將開課",
      "week": {
        "0": "星期日",
        "1": "星期一",
        "2": "星期二",
        "3": "星期三",
        "4": "星期四",
        "5": "星期五",
        "6": "星期六"
      },
      "noClass": "沒有課堂"
    },
    "details": {
      "gender": "性別",
      "male": "男",
      "female": "女",
      "dateOfBirth": "出生日期",
      "age": "年齡",
      "yearsOld": " 歲",
      "height": "高度",
      "weight": "體重",
      "headSize": "頭圍",
      "school": "學校",
      "disability": "診斷",
      "remark": "備註",
      "leaveType": {
        "sick": "病假",
        "casual": "事假"
      },
      "physicalAbility": "身體能力",
      "walk": "行走",
      "medication": "藥物",
      "previousRidingExperience": "過往騎馬經驗",
      "others": "其他",
      "volunteerAssigned": "指定義工",
      "assignedTask": "分配任務",
      "equipmentAssigned": "指定器材",
      "horseAssigned": "指定馬匹",
      "unitRiders": "騎生",
      "riders": "騎生",
      "yes": "是",
      "no": "否",
      "agreeTakePhoto": "同意拍照",
      "disagreeTakePhoto": "不同意拍照",
      "confirmRidersAttendance": "確認騎生出席情況",
      "confirmVolunteersAttendance": "確認義工出席情況",
      "pairHorseEquipmentVolunteerWithRider": "將馬匹、裝備、義工與騎手配對",
      "undefined": "",
      "noDisability": "無殘疾",
      "noMedication": "無藥物",
      "noExperience": "無經驗",
      "leader": "領隊",
      "sideHelper": "輔助者",
      "notAssigned": "未分配",
      "informationShownOnVolunteerCoach": "義工顯示資料 - 教練",
      "informationShownOnVolunteer": "義工顯示資料",
      "term": "學期",
      "day": "日期: 星期",
      "time": "時間",
      "riderFullName": "騎生姓名",
      "nationality": "國籍",
      "languageUsed": "語言",
      "photographsFilmingConsent": "拍攝及錄影許可",
      "walkingAids": "步行輔助工具"
    },
    "availability": {
      "days": "周",
      "time": "時間",
      "yourSelections": "您的選擇",
      "submit": "提交",
      "am": "上午",
      "pm": "下午",
      "noAnyRecords": "沒有記錄",
      "timeslotUpdateSuccessfully": "首選時段已更新"
    },
    "class": {
      "termRide": "恆常課堂",
      "independentRide": "獨立騎生課堂",
      "groupRide": "一日騎馬樂"
    },
    "disability": {
      "autismSpectrumDisorders": "自閉症",
      "attentionDeficitAndHyperactivityDisorder": "專注力不足及過度活躍",
      "specificLearningDifficulties": "讀寫困難",
      "intellectualDisability": "智力障礙",
      "communicationDifficulties": "溝通困難",
      "visualImpairment": "視覺受損",
      "hearingImpairment": "聽覺受損",
      "behavioralAndEmotionalDifficulties": "情緒及行爲問題",
      "physicalDisability": "肢體傷殘",
      "others": "其他"
    },
    "mobility": {
      "independent": "獨立",
      "assistanceNeeded": "需協助",
      "unaided": "行動自如",
      "crutches": "拐杖",
      "walkingStick": "手杖",
      "walker": "助步車",
      "wheelchair": "輪椅",
      "others": "其他"
    },
    "leaveRequest": {
      "all": "全部",
      "pending": "待審批",
      "approved": "已記錄",
      "appliedDate": "申請日期",
      "type": "類型",
      "leaveType": {
        "sick": "病假",
        "casual": "事假"
      },
      "newLeaveRequest": "新的請假申請",
      "pleaseSelectYourClass": "請選擇您的課堂",
      "noAnyRecords": "沒有記錄",
      "submit": "提交",
      "leaveRequestAddedSuccessfully": "請假請求已添加",
      "mins": "分鐘"
    },
    "accountSetting": {
      "updatePassword": "更新密碼",
      "currentPassword": "當前密碼",
      "newPassword": "新密碼",
      "confirmPassword": "確認密碼",
      "showPassword": "顯示密碼",
      "submit": "提交",
      "cancel": "取消",
      "passwordRequired": "密碼是必填項。",
      "passwordNotMatch": "密碼不匹配。",
      "passwordAtLeast6Char": "密碼至少6個字元。",
      "pleaseFill": "請填寫",
      "passwordUpdateSuccessfully": "密碼已成功修改",
      "originPasswordIncorrect": "原本密碼不正確"
    },
    "assessment": {
      "assessment": "評估",
      "communication": "溝通",
      "select": "選擇",
      "confident": "自信",
      "enjoyment": "樂趣",
      "horsemanship": "騎馬技巧",
      "physicalChange": "身體變化",
      "submit": "提交",
      "assessmentUpdateSuccessfully": "評估已更新",
      "confirm": "確認",
      "assessor": "評估員",
      "confirmer": "確認員",
      "confirmTitle": "確認評估",
      "confirmMessage": "確認提交後評估資訊將不能修改，請問確定提交本次評估嗎？",
      "cancel": "取消"
    },
    "volunteerAttendance": {
      "name": "姓名",
      "attendance": "出席狀況",
      "confirm": "確認",
      "present": "出席",
      "absent": "缺席",
      "late": "遲到",
      "excused": "請假獲准",
      "noVolunteer": "無義工",
      "attendanceUpdateSuccessfully": "義工簽到狀態已更新"
    },
    "riderPairing": {
      "volunteer": "義工",
      "selectVolunteer": "選擇義工",
      "leader": "領隊",
      "sideHelper": "輔助員",
      "submit": "提交",
      "equipment": "裝備",
      "selectEquipment": "選擇裝備",
      "horse": "馬匹",
      "selectHorse": "選擇馬匹",
      "pairingUpdateSuccessfully": "配對已更新"
    },
    "errorMsg": {
      "Current password is incorrect": "原本密碼不正確",
      "The new password must be at least 8 characters.": "新密碼必須至少為8個字元"
    },
    "register": {
      "register": "註冊",
      "seeTheDateTime": "查看日期和時間",
      "tuenMunPublicRidingSchool": "屯門公眾騎術學校",
      "tuenMunPublicRidingSchoolAddress": "新界屯門龍門路四十五號地段",
      "pokfulamPublicRidingSchool": "薄扶林公眾騎術學校",
      "pokfulamPublicRidingSchoolAddress": "香港薄扶林水塘道75號",
      "leiYueMunPublicRidingSchool": "鯉魚門公眾騎術學校",
      "leiYueMunPublicRidingSchoolAddress": "柴灣峽柴灣道75號",
      "monToFri": "周一至周五",
      "monToSat": "周一至周六",
      "monToWedFri": "周一至周三及周五",
      "part": "部分",
      "sat": "周六",
      "wedAndFri": "周三及周五",
      "tueAndThu": "周二及周四",
      "am": "上午",
      "pm": "下午",
      "back": "上一步",
      "next": "下一步",
      "yes": "是",
      "no": "否",
      "confirm": "確認",
      "pleaseEnter": "請輸入。",
      "pleaseSelect": "請選擇。",
      "email": "電子郵件",
      "password": "密碼",
      "confirmPassword": "確認密碼",
      "showPassword": "顯示密碼",
      "englishName": "英文姓名",
      "chineseName": "中文姓名",
      "gender": "性別",
      "male": "男",
      "female": "女",
      "dateOfBirth": "出生日期",
      "idCardNo": "身份證號碼",
      "phoneNumber": "電話號碼",
      "occupation": "職業",
      "address": "地址",
      "registerSuccessfully": "註冊成功",
      "privacyRegisterRequired": "註冊時，用户需要閱讀並接受網站之條款及細則 以及 私隱條例。",
      "fullName": "姓名",
      "relationship": "關係",
      "expRFD": "殘疾人士騎術經驗",
      "RHExp": "騎術/馬術經驗",
      "medExp": "醫療經驗",
      "knowAndExp": {
        "label": "知識和經驗",
        "pvMaking": "攝影/視頻製作",
        "workWithChild": "與兒童工作",
        "workWithPD": "與殘疾人士工作",
        "media": "媒體"
      },
      "howDidFind": {
        "label": "您是如何得知RDA香港的？",
        "rdaHKWebsite": "RDA香港網站",
        "rdaFacebook": "RDA Facebook",
        "searchEngine": "搜尋引擎",
        "friends": "朋友",
        "others": "其他（請說明）"
      },
      "contactNumber": "聯繫電話",
      "relWithReferer": "與推薦人關係",
      "declaration1": "本人謹此聲明，在香港傷健策骑協會有限公司習骑活動擔當義工所遇到的一切風險，將由本人自行承擔，並同意對本人的言行負責。",
      "declaration2": "本人願意在香港傷健策騎協會有限公司習騎活動擔當義工時遵守兒童及脆弱成人保障政策以及義工工作指引。",
      "iAgreeTo": "我同意",
      "consentRaR": "RDA規章制度",
      "consentVWG": "義工工作指南",
      "consentIF2016": "RDA豁免責任表格2016",
      "personalInformation": "個人資料",
      "emergencyContact": "緊急聯絡人",
      "locationPreference": "地點偏好",
      "locationPreferenceTip": "選擇您偏好的地點（可選擇多個地點）",
      "knowledgeExperience": "知識和經驗",
      "knowledgeExperienceTip": "以下資訊有助於我們充分利用您的知識和經驗。請告訴我們您想要參與的工作！",
      "volunteerReferralScheme": "RDA義工推薦計劃（如適用）",
      "declarationConsent": "聲明和同意",
      "declarationTip": "請勾選以下內容以確認您的申請",
      "consentTip": "請勾選以下內容以表明您的同意"
    }
  },
  "validation": {
    "passwordPattern": "密碼長度不少於8個字位，必需包含至少一個大階和細階字母，及一個非字母字符。",
    "phoneMinDigits": "請至少輸入8位數字"
  },
  "FOOTER": {
    "TUEN_MUN": "屯門公眾騎術學校",
    "POKFULAM": "薄扶林公眾騎術學校",
    "TEL": "電話：",
    "EMAIL": "電郵：",
    "WEBSITE": "網址：",
    "CHARITY_REG": "慈善機構註冊編號：",
    "COPYRIGHT": "香港傷健策騎協會有限公司 版權所有",
    "COPYRIGHT_ORG": "Riding for the Disabled Association Ltd.",
    "COPYRIGHT_ORG_ZH": "香港傷健策騎協會有限公司版權所有",
    "COPYRIGHT_RESERVED": "保留所有權利。"
  },
  "consentCVASP": "RDA兒童及易受傷害成年人保障政策",
  "consentRaR": "RDA規章制度",
  "consentVWG": "義工工作指南",
  "consentIF2016": "RDA豁免責任表格2016"
}
